import { render, staticRenderFns } from "./BsModal.vue?vue&type=template&id=7e8995a6&"
import script from "./BsModal.vue?vue&type=script&lang=js&"
export * from "./BsModal.vue?vue&type=script&lang=js&"
import style0 from "./BsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports